// extracted by mini-css-extract-plugin
export default {"trigger":"Select_trigger__O2JXL","content":"Select_content__YFFlf","separator":"Select_separator__a5t+K","item":"Select_item__dYIw9"};